export default __webpack_public_path__ + "static/media/planvital.58dc4619.png";